module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori-4f898abfb1d18fb0103f0271484b0576.webp";